import { NgModule } from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatInputModule} from '@angular/material/input';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';

@NgModule({
    imports : [
        MatToolbarModule, 
        MatTabsModule, 
        MatInputModule,
        MatGridListModule,
        MatRadioModule,
        MatSelectModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule, 
        MatSnackBarModule,
        MatStepperModule,
        MatChipsModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatSlideToggleModule,
        MatListModule,
        MatMenuModule
    ],
    exports : [
        MatToolbarModule, 
        MatTabsModule,
        MatInputModule,
        MatGridListModule,
        MatRadioModule,
        MatSelectModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatSnackBarModule,
        MatStepperModule,
        MatChipsModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatSlideToggleModule,
        MatListModule,
        MatMenuModule
    ]
})

export class MaterialModule {}
